/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderSearchResult } from './ProviderSearchResult';
import {
    ProviderSearchResultFromJSON,
    ProviderSearchResultFromJSONTyped,
    ProviderSearchResultToJSON,
    ProviderSearchResultToJSONTyped,
} from './ProviderSearchResult';

/**
 * 
 * @export
 * @interface SearchProviderDirectoryResponse
 */
export interface SearchProviderDirectoryResponse {
    /**
     * 
     */
    data: Array<ProviderSearchResult>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the SearchProviderDirectoryResponse interface.
 */
export function instanceOfSearchProviderDirectoryResponse(value: object): value is SearchProviderDirectoryResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function SearchProviderDirectoryResponseFromJSON(json: any): SearchProviderDirectoryResponse {
    return SearchProviderDirectoryResponseFromJSONTyped(json, false);
}

export function SearchProviderDirectoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchProviderDirectoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ProviderSearchResultFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function SearchProviderDirectoryResponseToJSON(json: any): SearchProviderDirectoryResponse {
    return SearchProviderDirectoryResponseToJSONTyped(json, false);
}

export function SearchProviderDirectoryResponseToJSONTyped(value?: SearchProviderDirectoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ProviderSearchResultToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

